export default __webpack_public_path__ + "static/zoom-with-zupr-c8074d033ed6952c7ff21020dbf22ac1.png";